'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRotateCanvas = exports.getResizeCanvas = exports.getOrientation = exports.getCanvas = exports.getResizeImage = exports.getExifRotateCanvas = exports.init = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _exifJs = require('exif-js');

var _exifJs2 = _interopRequireDefault(_exifJs);

var _configs = require('./configs');

var _loadImage = require('./load-image');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var makeCanvas = function () {
  function makeCanvas() {
    _classCallCheck(this, makeCanvas);
  }

  _createClass(makeCanvas, null, [{
    key: 'init',

    /**
    *  get canvas after read file
    *  @param files {fileList}
    *  @return promise {func}
    */
    value: function init(files, options) {
      var tasks = [];

      var _loop = function _loop(i) {
        var task = new Promise(function (resolve) {
          (0, _loadImage.readFile)(files[i]).then(function (file) {
            return (0, _loadImage.setImage)(file).then(function (img) {
              return resolve(getExifRotateCanvas(img, options));
            });
          });
        });
        tasks.push(task);
      };

      for (var i = 0; i < files.length; i += 1) {
        _loop(i);
      }

      return Promise.all(tasks).then(function (canvas) {
        return canvas;
      });
    }

    /**
    *  insert resize variable to image
    *  @param img {elem}
    *  @return img {elem}
    */

  }, {
    key: 'getResizeImage',
    value: function getResizeImage(img) {
      img.re_width = img.width;
      img.re_height = img.height;
      var orientation = getOrientation(img);
      if (orientation === 6) {
        // it is necessary to manually replace width and height for mobile
        img.re_height = img.width;
        img.re_width = img.height;
      }

      return img;
    }

    /**
    *  get resize and rotate canvas
    *  @param img {elem}
    *  @param options {object}
    *  @return canvas {elem}
    */

  }, {
    key: 'getExifRotateCanvas',
    value: function getExifRotateCanvas(img, options) {
      var resizeCanvas = getResizeCanvas(getResizeImage(img), options);
      var ctx = resizeCanvas.getContext('2d');

      return getRotateCanvas(getOrientation(img), img, ctx, resizeCanvas);
    }

    /**
    *  get canvas to designate size from original size
    *  @param resizeImage {elem}
    *  @param options {object}
    *  @returns canvas {elem}
    */

  }, {
    key: 'getResizeCanvas',
    value: function getResizeCanvas(resizeImage, options) {
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      var size = options.max_size ? options.max_size : _configs.max_size;

      if (resizeImage.re_width > resizeImage.re_height) {
        var resize = resizeImage.re_height * (size / resizeImage.re_width);
        canvas.width = size;
        canvas.height = resize;
        ctx.drawImage(resizeImage, 0, 0, size, resize);
        return canvas;
      } else if (resizeImage.re_height > resizeImage.re_width) {
        var _resize = resizeImage.re_width * (size / resizeImage.re_height);
        canvas.width = _resize;
        canvas.height = size;
        ctx.drawImage(resizeImage, 0, 0, _resize, size);
        return canvas;
      }

      canvas.width = size;
      canvas.height = size;
      ctx.drawImage(resizeImage, 0, 0, size, size);
      return canvas;
    }

    /**
    *  get orientation for mobile
    *  @param img {elem}
    *  @return orientation {number}
    */

  }, {
    key: 'getOrientation',
    value: function getOrientation(img) {
      var orientation = void 0;
      _exifJs2.default.getData(img, function () {
        orientation = _exifJs2.default.getTag(img, 'Orientation');
      });
      return orientation;
    }

    /**
    *  get rotate canvas for mobile
    *  @param orientation {number}
    *  @param img {elem}
    *  @param ctx {canvas obj}
    *  @param canvas {elem}
    *  @returns canvas {elem}
    */

  }, {
    key: 'getRotateCanvas',
    value: function getRotateCanvas(orientation, img, ctx, canvas) {
      switch (orientation) {
        case 2:
          // horizontal flip
          ctx.translate(canvas.width, 0);
          ctx.scale(-1, 1);
          return canvas;
        case 3:
          // 180° rotate left
          ctx.translate(canvas.width, canvas.height);
          ctx.rotate(Math.PI);
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          return canvas;
        case 4:
          // vertical flip
          ctx.translate(0, canvas.height);
          ctx.scale(1, -1);
          return canvas;
        case 5:
          // vertical flip + 90 rotate right
          ctx.rotate(0.5 * Math.PI);
          ctx.scale(1, -1);
          return canvas;
        case 6:
          {
            // 90° rotate right
            ctx.rotate(0.5 * Math.PI);
            ctx.translate(0, -canvas.height);
            var img_ratio = img.re_height / img.re_width - 1;
            ctx.drawImage(img, 0, canvas.width * img_ratio, canvas.height, canvas.width);
            return canvas;
          }
        case 7:
          // horizontal flip + 90 rotate right
          ctx.rotate(0.5 * Math.PI);
          ctx.translate(canvas.width, -canvas.height);
          ctx.scale(-1, 1);
          return canvas;
        case 8:
          // 90° rotate left
          ctx.rotate(-0.5 * Math.PI);
          ctx.translate(-canvas.width, 0);
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          return canvas;
        default:
          return canvas;
      }
    }
  }]);

  return makeCanvas;
}();

exports.default = makeCanvas;
var init = makeCanvas.init,
    getExifRotateCanvas = makeCanvas.getExifRotateCanvas,
    getResizeImage = makeCanvas.getResizeImage,
    getCanvas = makeCanvas.getCanvas,
    getOrientation = makeCanvas.getOrientation,
    getResizeCanvas = makeCanvas.getResizeCanvas,
    getRotateCanvas = makeCanvas.getRotateCanvas;
exports.init = init;
exports.getExifRotateCanvas = getExifRotateCanvas;
exports.getResizeImage = getResizeImage;
exports.getCanvas = getCanvas;
exports.getOrientation = getOrientation;
exports.getResizeCanvas = getResizeCanvas;
exports.getRotateCanvas = getRotateCanvas;


//////////////////
// WEBPACK FOOTER
// ./node_modules/exif-rotate-js/lib/make-canvas.js
// module id = 916
// module chunks = 0